import { render } from "./MfaSendCode.vue?vue&type=template&id=44b53e22"
import script from "./MfaSendCode.vue?vue&type=script&lang=js"
export * from "./MfaSendCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__